module.exports = __webpack_public_path__ + "static/media/74.7fcdb3da.png";